import type * as React from 'react';
import { getIntrinsicElementProps, slot } from '@fluentui/react-components';
import type { GroundingMenuProps, GroundingMenuState } from './GroundingMenu.types';

// If you add JSX to this file, be sure to change the file type to .tsx

/**
 * Create the state required to render GroundingMenu.
 *
 * The returned state can be modified with hooks such as useGroundingMenuStyles_unstable,
 * before being passed to renderGroundingMenu_unstable.
 *
 * @param props - props from this instance of GroundingMenu
 * @param ref - reference to root HTMLElement of GroundingMenu
 */
export const useGroundingMenu_unstable = (
  props: GroundingMenuProps,
  ref: React.Ref<HTMLDivElement>,
): GroundingMenuState => {
  return {
    // TODO add appropriate props/defaults
    components: {
      // TODO add each slot's element type or component
      root: 'div',
    },
    // TODO add appropriate slots, for example:
    // mySlot: slot.optional(props.mySlot),
    root: slot.always(
      getIntrinsicElementProps('div', {
        ref,
        ...props,
      }),
      { elementType: 'div' },
    ),
  };
};
